import { render, staticRenderFns } from "./Hotspot.vue?vue&type=template&id=f55570c8&scoped=true"
import script from "./Hotspot.vue?vue&type=script&lang=ts"
export * from "./Hotspot.vue?vue&type=script&lang=ts"
import style0 from "./Hotspot.vue?vue&type=style&index=0&id=f55570c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55570c8",
  null
  
)

export default component.exports